<!--We were checking url is ICM page or dotCMS page using regex pattern-->
<ng-container *ngIf="isContentPage$ | async; else dotCmsPageContent">
  <ish-content-page />
</ng-container>
<ng-template #dotCmsPageContent>
  <custom-lazy-dot-cms-default-page *ishFeature="'dotCms'" />
</ng-template>
